import { EventHelper, Field } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import intlTelInput from 'intl-tel-input';

function formatIntlTelInput(itlInputEl) {
  if (itlInputEl) {
    if (typeof window.intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
      const currentText = itlInputEl.getNumber(window.intlTelInputUtils.numberFormat.E164);
      if (typeof currentText === 'string') { // sometimes the currentText is an object :)
        itlInputEl.setNumber(currentText); // will autoformat because of formatOnDisplay=true
      }
    }
  }
}

function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="No browser detection";
  }
  return browserName
}

export class SwivuPhoneField extends Field {

  static get type() {
    return WIDGET_KEYS.fieldPhone;
  }

  static get configurable() {
    return {
      cls: "b-textfield b-swivuphonefield",
      listeners: {
        input: (e) => formatIntlTelInput(e.source.itlInputEl),
        paint() {
          this.swivuCellEditorContext = this.parent?.cellEditorContext;
        },
        change(e) {
          this.swivuCellEditorContext = this.parent?.cellEditorContext;
          // fix require, currently when field load it doesn't display country flag for number so adding timeout for fix
          setTimeout(() => {
            formatIntlTelInput(this.itlInputEl);
            // in case if user paste number with 0 prefix then we need to update the record otherwise old value with 0 prefix get save
            if (e.value?.startsWith("0")) {
              this.parent.record[this.name] = this.itlInputEl.telInput.value;
            }
          }, 0);
        },
      }
    }
  }

  get isValid() {
    if (this.value?.trim?.().length && this.itlInputEl) return this.itlInputEl.isValidNumber();
    return super.isValid;
  }

  getErrors() {
    return ["Phone number is not valid"]
  }

  onHideCountryListDD(e) {
    // e.target.className should be string but since EventHelper below capture events from everything in document, the e.target.className can be an object.
    if (this.itlInputEl && typeof e.target?.className === "string" && e.target.className.indexOf("iti__") === -1) this.itlInputEl._closeDropdown();
  }

  construct() {
    super.construct(...arguments);
    if (this.input) {
      EventHelper.on({
        element : document.body,
        click   : 'onHideCountryListDD',
        thisObj : this,
      });
      this.itlInputEl = intlTelInput(this.input, {
        utilsScript: "/js/intl-tel-input/utils.js",
        // preferredCountries: ['US'],
        nationalMode: false,
        formatOnDisplay: true, // SET THIS!!!
        // separateDialCode: true,
        dropdownContainer: document.body,
        initialCountry: "",
        autoPlaceholder: "aggressive",
      });

      // the countryChange event gets triggered whenever we change country from either selecting dropdown item or changing country code in input
      this.input.addEventListener("countrychange", (e) => {
        // whenever we select the country from dropdown the editor loose focus and finish cell editing, this will prevent that behavior
        if (this.swivuCellEditorContext && !this.parent.editing) {
          setTimeout(() => {
            this.swivuCellEditorContext.grid.startEditing(this.swivuCellEditorContext);
          }, 0);
        }
        if (this.parent.record && this.isValid) this.parent.record[this.name] = e.target.value;
      });

      //attaching listener for safari
      if (fnBrowserDetect() === "safari"){
        this.input.addEventListener("blur", () => {
          if (this.isValid) {
            this.parent.record[this.name] = this.value
          }
        })
      }
    }
  }
}

SwivuPhoneField.initClass();
